/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
import { useI18n } from 'vue-i18n';
import showformmodel from "../showformmodel/showformmodel.vue"
import AssignEproPopup from "../AssignEproPopup/AssignEproPopup.vue";
import customModal from "../customModal/customModal.vue";
import viewAlertDetailsPopup from '../viewAlertDetailsPopup/viewAlertDetailsPopup.vue';
import AlertStatusPopup from '../AlertStatusPopup/AlertStatusPopup.vue';
import viewAlertQueryPopup from '../ViewAlertQuery/viewAlertQueryPopup.vue';
import moment from "moment";
export default {
  components: {
    showformmodel,
    customModal,
    AssignEproPopup,
    viewAlertDetailsPopup,
    AlertStatusPopup,
    viewAlertQueryPopup
  },
  name: "organization_settings",
  
};
